<template>
  <div id="app" class="container">
    <Header />
    <WidgetGenerator/>
  </div>
</template>

<script>
import Header from './components/Header.vue';
import WidgetGenerator from './components/WidgetGeneratorMain.vue';

export default {
  name: 'App',
  components: {
    Header,
    WidgetGenerator,
  },
  data: function() {
    return {
      activeTab: 1,
      activeTabSearch: 1,
    };
  },
};
</script>
